import { RegistryItem } from "@schemas/agreements/schema";
import { AgreementTypeEnum, CalculationMethodType } from "__generated__/graphql";
import { QuantityUnit } from "__generated__/enums.ts";

export const PostCalculationSchema: RegistryItem = {
	[AgreementTypeEnum.PostCalculation]: {
		defaultValues: {
			calculationMethod: {
				type: CalculationMethodType.QuantityUnit,
				quantityUnit: QuantityUnit.Custom,
			},
		},
		agreementFields: {
			"agreement.manualActionRequired": { rules: { hidden: true } },
		},
		calculationMethodFields: {
			"calculationMethod.quantityUnit": { rules: { hiddenIf: ({ calculationMethodType }) => calculationMethodType === CalculationMethodType.QuantityUnit } },
		},
	},
};
